import { useSeoMeta } from 'unhead'
import { h, inject } from 'vue'
import { useQuery, useQueryClient } from 'vue-query'
import { useRoute } from 'vue-router'
import { useTippy } from 'vue-tippy'

import { useAuthStore } from '@/store/auth.js'
import { useGlobalStore } from '@/store/global.js'

import UIAuthTippy from '@/components/ui/UIAuthTippy.vue'

/**
 * @param {String} rootKey - request root
 * @param {String} queryKey - tanstack query key
 * @param {String} subscribeKey subscribe key
 * @param {Function} select - destructuring request data
 */
export function usePageId({ rootKey, queryKey, subscribeKey, select }) {
  const http = inject('http')
  const route = useRoute()
  const client = useQueryClient()

  const global = useGlobalStore()
  const auth = useAuthStore()

  function usePageQuery() {
    return useQuery({
      queryKey: [queryKey, route.params.id],
      queryFn: () =>
        http(`/${rootKey}/${route.params.id}`).then((res) => {
          useSeoMeta({
            title: res.resource.title,
          })
          return res
        }),
      select: (data) => {
        return select ? select(data) : data.resource
      },
    })
  }

  function createTippy(element) {
    if (!element && element.target) return

    const { hide, show } = useTippy(element.target, {
      content: h(UIAuthTippy, {
        body: 'Чтобы добавить в избранное',
        hide: () => hide(),
      }),
      appendTo: () => document.body,
      placement: 'bottom-end',
      arrow: false,
      trigger: 'manual',
      interactive: true,
      zIndex: 9999,
    })
    show()
  }

  function toggleSubscribe() {
    client.setQueryData([queryKey, route.params.id], (data) => {
      return {
        ...data,
        subscribed: !data.subscribed,
      }
    })
  }

  function subscribe(element) {
    http(`/${subscribeKey ?? rootKey}/${pageState.data.value.id}/subscribe`, {
      method: 'POST',
    })
      .then(() => {
        toggleSubscribe()
      })
      .catch(() => {
        createTippy(element)
      })
  }

  const pageState = usePageQuery()

  return {
    http,
    route,
    global,
    auth,
    client,
    pageState,
    subscribe,
  }
}
